export const MAGNET_DISABLED_MSG = {
  size: "This size isn't available for magnets",
  silhouette: "This shape isn't available for magnets",
} as const;

export const DISABLED_MSG = {
  type: 'This item is out of stock and cannot be shipped.',
  medium: "This type isn't available for this card",
  size: "This size isn't available for the current card type",
  'paper-type': {
    pearlized: 'This paper type is currently out of stock.',
    default: "This paper type isn't available with your current selections",
  },
  silhouette: `This shape isn't available with your current selections`,
} as const;

export const BASE_PAPER_SHAPES = ['square', 'rounded'] as const;
export const ALL_PAPER_SHAPES = [
  'square',
  'rounded',
  'scalloped',
  'arch',
  'ticket',
  'diamond',
] as const;

type AllPaperShape = typeof ALL_PAPER_SHAPES[number];
export const isAllPaperShape = (shape?: string): shape is AllPaperShape => {
  return Boolean(shape && ALL_PAPER_SHAPES.includes(shape as AllPaperShape));
};

export const THICK_PAPER_TYPES = ['double-thick', 'triple-thick'] as const;

export const HEX_COLOR_OPTION_KEYS = ['color', 'napkin-color'];
